export default __webpack_public_path__ + "static/media/bg.c70e9ad7.png";